import React from "react";
import PropTypes from "prop-types";
import PersonPreview from "components/PersonPreview";
import Icon from "components/Icon";
import classNames from "classnames";
import { profileType } from "domain/User/types";
import { getProfileFields } from "pages/Profile/Card/fields";
import Button from "ui/Button";
import Tooltip from "ui/Tooltip";

const ProfileDetails = ({
    profile,
    cityName,
    isLoggedIn,
    unauthorizedMessage,
    isCustomFields,
}) => {
    const profileFields = getProfileFields({ profile, cityName }).map(
        (field) => ({
            ...field,
            isCustom: isCustomFields?.includes(field.name) && field.value === "",
        })
    );

    const renderField = ({ name, value, icon, classes, isCustom }) => {
        return (
            <li key={name}>
                <span className="icon-container">
                    <Icon type={icon} />
                </span>
                <p className="profile__param">{name}</p>
                <p className={classNames("profile__value", classes)}>
                    {isCustom ? customFields(name) : value}
                </p>
            </li>
        );
    };

    const customFields = (name) => {
        switch (name) {
            case "Номер телефона":
                return (
                    <Tooltip
                        message="Виден только для тех игроков, которые сами записались на
                            вашу игру."
                        placement="bottom"
                    >
                        <a>недоступен</a>
                        <Icon type="info" />
                    </Tooltip>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <PersonPreview
                {...profile}
                fullAvatar
                mods={[`profile__person person--profile`]}
            />
            {!isLoggedIn ? (
                <div>
                    <p className="fs-body1 c-gs-medium-em mb-32-40 text-center">
                        {unauthorizedMessage}
                    </p>
                    <div className="flex jcc">
                        <Button primary linkTo="/signin">
                            Войти, чтобы посмотреть
                        </Button>
                    </div>
                </div>
            ) : (
                <ul className="profile__list">
                    {profileFields
                        .filter((item) => !!item.value || item.isCustom)
                        .map(({ name, value, icon, classes, isCustom }) =>
                            renderField({
                                name,
                                value,
                                icon,
                                classes,
                                isCustom,
                            })
                        )}
                </ul>
            )}
        </>
    );
};

ProfileDetails.defaultProps = {
    unauthorizedMessage:
        "Вы не можете посмотреть личную информацию про организатора.",
};

ProfileDetails.propTypes = {
    profile: profileType,
    cityName: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    unauthorizedMessage: PropTypes.string,
    isCustomFields: PropTypes.array,
};

export default ProfileDetails;
